module.exports = __webpack_public_path__ + "static/media/form-banner.546845a5.png";